import { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/uiParts/hygiene/Header';
import EditNoteIcon from '@mui/icons-material/EditNote';
import TitleBar from '../../components/uiParts/TitleBar';
import MenuIcon from '../../components/uiParts/MenuIcon';
import PrintIcon from '@mui/icons-material/Print';
import FolderIcon from '@mui/icons-material/Folder';
import { useAuth } from '../../contexts/AuthContext';
import MonitorIcon from '@mui/icons-material/Monitor';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarningIcon from '@mui/icons-material/Warning';

const HomeHygiene = () => {
    
    const navigate = useNavigate();
    
	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo } = useAuth();
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const userName       = authInfo.userName;
    const lobinAuthority = authInfo.authority;
    const today          = authInfo.targetDate;

    //===============================================
    // API
    //===============================================
	//===============================================
	// useEffect
	//===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {
    },[]);
    //-----------------------------------------------
    // useLayoutEffect - iPad Safari 初回レンダリング対策
    // 描画前に同期実行されるため、ブラウザは ready=true の状態のみを描画する
    //-----------------------------------------------
    const [ready, setReady] = useState(false);
    useLayoutEffect(() => {
        setReady(true);
    }, []);
    
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//-----------------------------------------------
    // eventHandler - 画面遷移
	//-----------------------------------------------
    const handleClick = (url) => {
        navigate(url);
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    if (!ready) return null;
    return (
        <>
        <Header loginInfo="on" backButton="off" backPage="/" setEntryDate={handleChange_entryDate} />
            <div className='homeHygiene' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="高度衛生管理メニュー" color="#d66a35" />
                    <MenuIcon header="Hygiene Menu" title="データ入力" onClick={() => handleClick('/hygineList')} color="#d66a35">
                        <EditNoteIcon style={{fontSize: '4rem', color: '#d66a35'}} />
                    </MenuIcon>
                    <MenuIcon header="Hygiene Menu" title="帳票出力"  onClick={() => handleClick('/hygieneReportMenu')} color="#d66a35">
                        <PrintIcon style={{fontSize: '4rem', color: '#d66a35'}} />
                    </MenuIcon>
                    <MenuIcon header="Hygiene Menu" title="電子入札へ"  onClick={() => handleClick('/home')} color="#d66a35">
                        <ShoppingCartIcon style={{fontSize: '4rem', color: '#d66a35'}} />
                    </MenuIcon>
                </div>
                <div>
                    <TitleBar title="モニタリングメニュー" color="#d66a35" />
                    <MenuIcon header="Monitoring Menu" title="水質モニター" onClick={() => handleClick('/aqualiumMonitor')} color="#d66a35">
                        <MonitorIcon style={{fontSize: '4rem', color: '#d66a35'}} />
                    </MenuIcon>
                    <MenuIcon header="Monitoring Menu" title="アラートリスト"  onClick={() => handleClick('/hygineAlertList')} color="#d66a35">
                        <WarningIcon style={{fontSize: '4rem', color: '#d66a35'}} />
                    </MenuIcon>
                </div>
                { lobinAuthority == 1 ? 
                <div>
                    <TitleBar title="管理メニュー" color="#d66a35" />
                    <MenuIcon header="Management Menu" title="衛生管理マスタ"  onClick={() => handleClick('/hygieneMastaMenu')} color="#d66a35">
                        <FolderIcon style={{fontSize: '4rem', color: '#d66a35'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
            </div>
        </>
    )
}
export default HomeHygiene;